import {
	callAdyenWebhook,
	display,
	fetchPropertyInfo,
	fetchReservation,
	fetchReservationProfiles,
	fetchToken,
	resetPostComplete,
	selectSession,
} from '../redux/slices/sessionSlice';
import {
	completeStage,
	fetchStages,
	missing,
	postResetStage,
	selectStage,
} from '../redux/slices/stageSlice';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { bypassConfirmLeaveOnce } from '../hooks/confirmLeavePageBypass';
import GuestOtpValidationForm from './guest-otp-validation/components/guestOtpValidation';
import GuestVerificationHome from './guest-verification/page';
import { isMobileDevice } from '../utils';
import LetsGetStarted from './det/lets-get-started/page';
import Loading from '../components/loading';
import { onboardingState } from '../redux/slices/detSlice';
import PrivacyStatement from './det/privacy-statement/page';
import QRReservationSearch from './qr-reservation/page';
import { regeneratePrecheckinLink } from '../redux/api';
import ReservationProfileFormHome from './reservation-profile-form/page';
import { selectDocuments } from '../redux/slices/documentSlice';
import { selectProfile } from '../redux/slices/profileSlice';
import SendRegistrationCardHome from './send-registration-card/page';
import Swal from 'sweetalert2';
import { useConfirmLeavePage } from '../hooks/useConfirmLeavePage';
import { useSearchParams } from 'react-router-dom';

export default function DisplayPage() {
	useConfirmLeavePage({
		enabled: true,
		message:
			'Are you sure you want to leave this page? Your progress may be lost.',
	});

	const [searchParams] = useSearchParams();

	const isQR =
		(searchParams.get('qr') || '').toString() === '1' ||
		window.location.pathname.toLowerCase().includes('/qr');

	if (isQR) return <QRReservationSearch />;
	const dispatch = useAppDispatch();

	const { stages, stage } = useAppSelector(selectStage);
	const { supportDocs } = useAppSelector(selectDocuments);
	const {
		token,
		propertyInfo,
		uiProperties,
		reservation,
		profiles,
		isPostComplete: isSessionPostComplete,
		loading,
		error,
		guestVerificationLazyLoad,
	} = useAppSelector(selectSession);
	const { currentProfile } = useAppSelector(selectProfile);
	const { onboardingToken } = useAppSelector(onboardingState);

	const [showStage, setShowStage] = useState(false);
	const [guestWithMe, setGuestWithMe] = useState<boolean | null>(null);
	const [regenerateReservationNo, setRegenerateReservationNo] = useState('');
	const [regenerateArrivalDate, setRegenerateArrivalDate] = useState('');
	const [regenerateEmail, setRegenerateEmail] = useState('');
	const [isRegeneratingLink, setIsRegeneratingLink] = useState(false);
	const [regenerateError, setRegenerateError] = useState('');
	const [regenerateSuccess, setRegenerateSuccess] = useState('');
	const [isMagicTokenMissing, setIsMagicTokenMissing] = useState(false);
	const [isMagicAuthResolved, setIsMagicAuthResolved] = useState(false);

	const renderStage = () => {
		if (!stage) return null;

		const isStage5 =
			stage.stepID === 5 ||
			stage.stepCode === 'SEI05' ||
			stage.stageCode === 'SEI05';

		const isPrivacyPloicy =
			stage.stepID === 3 ||
			stage.stepCode === 'SEI03' ||
			stage.stageCode === 'SEI03';

		// const isSendRegCardStage =
		// 	stage.stepID === 2 ||
		// 	stage.stepCode === 'SEI02' ||
		// 	stage.stageCode === 'SEI02';

		const propertyLogoUrl =
			propertyInfo?.logo ||
			propertyInfo?.logoUrl ||
			propertyInfo?.propertyLogo ||
			'';

		const renderStageLogo = () => {
			if (isPrivacyPloicy) {
				return <div className="app-logo" />;
			}
			if (propertyLogoUrl) {
				return (
					<div
						className="property-logo"
						style={{ backgroundImage: `url(${propertyLogoUrl})` }}
					/>
				);
			}
			return (
				<div
					className="property-logo"
					style={{ backgroundImage: `url(${'/assets/icons/logo-hd.png'})` }}
				/>
			);
		};

		if (loading && !isStage5) return null;

		if (isLoadingStage) {
			return renderLoading();
		}

		return (
			<>
				{/* Back Arrow & Logo */}
				<div
					className="d-flex align-items-center w-100 position-relative"
					style={{
						minHeight: '80px',
						borderBottom: '1px solid #e7e7e7',
						boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
					}}>
					<button
						onClick={handleBack}
						className="btn p-0 position-absolute"
						style={{
							left: '20px',
							zIndex: 1,
							fontSize: '1.5rem',
							lineHeight: 1,
							color: 'var(--primary-color)',
						}}>
						<img
							className="align-middle"
							src={process.env.PUBLIC_URL + '/arrow-left.png'}
							alt="Back"
						/>
					</button>
					{renderStageLogo()}
				</div>

				{isStage5 ? (
					<GuestVerificationHome />
				) : (
					<>
						{console.log('Stage', stage)}
						{stage.stepID === 2 ||
						stage.stepCode === 'SEI02' ||
						stage.stageCode === 'SEI02' ? (
							<>
								{console.log('Rendering OTP Stage')}
								<GuestOtpValidationForm guestWithMe={guestWithMe} />
								{/* <SendRegistrationCardHome /> */}
							</>
						) : stage.stepID === 3 ||
						  stage.stepCode === 'SEI03' ||
						  stage.stageCode === 'SEI03' ? (
							<>
								{console.log('Rendering PrivacyStatement Stage')}
								<PrivacyStatement />
							</>
						) : stage.stepID === 4 ||
						  stage.stepCode === 'SEI04' ||
						  stage.stageCode === 'SEI04' ? (
							<>
								{console.log('Rendering LetsGetStarted Stage')}
								<LetsGetStarted />
							</>
						) : stage.stepID === 6 ||
						  stage.stepCode === 'SEI06' ||
						  stage.stageCode === 'SEI06' ? (
							<>
								{console.log('Rendering Send Registration Card Stage')}
								<SendRegistrationCardHome />
							</>
						) : null}
					</>
				)}
			</>
		);
	};

	// useEffect(() => {
	// 	console.log('searchParams', searchParams.get('confirmationNumber'));
	// 	console.log('searchParams', searchParams.get('hotel'));
	// 	console.log('searchParams', searchParams.get('propertyCode'));
	// 	console.log('searchParams', searchParams.get('propertycode'));
	// 	console.log('searchParams', searchParams.get('reservation'));
	// 	console.log('searchParams', searchParams.toString());

	// 	const propertyCode =
	// 		searchParams.get('PropertyCode') ||
	// 		searchParams.get('propertyCode') ||
	// 		searchParams.get('propertycode') ||
	// 		searchParams.get('hotel');
	// 	if (!token && propertyCode) dispatch(fetchToken(propertyCode));
	// }, [searchParams]);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const magicToken =
			params.get('token') ||
			params.get('magicToken') ||
			params.get('x-magic-token') ||
			sessionStorage.getItem('magicToken');

		const initAuth = async () => {
			if (magicToken) {
				await dispatch(fetchToken(magicToken));
			} else {
				setIsMagicTokenMissing(true);
			}
			setIsMagicAuthResolved(true);
		};

		initAuth();

		setRegenerateReservationNo(
			params.get('confirmationNumber') || params.get('reservation') || ''
		);
	}, []);

	const handleBack = async () => {
		if (!stage) return;

		const result = await Swal.fire({
			title: 'Are you sure?',
			text: 'Your progress will be lost if you go back.',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, go back',
			cancelButtonText: 'Stay here',
			reverseButtons: true,
		});

		if (result.isConfirmed) {
			dispatch(
				postResetStage({
					token,
					profileId: currentProfile?.profileID ?? null,
					onboardingToken,
				})
			).then(() => {
				bypassConfirmLeaveOnce();
				window.location.reload();
			});
		}
	};

	const isLoadingStage =
		!stage ||
		stage.stepID === 10 ||
		stage.stepCode === 'SEI10' ||
		stage.stageCode === 'SEI10' ||
		stage.stepID === 13 ||
		stage.stepCode === 'SEI13' ||
		stage.stageCode === 'SEI13' ||
		(![2, 3, 4, 5, 6].includes(stage.stepID) &&
			!['SEI02', 'SEI03', 'SEI04', 'SEI05', 'SEI06'].includes(stage.stepCode) &&
			!['SEI02', 'SEI03', 'SEI04', 'SEI13', 'SEI10', 'SEI06', 'SEI05'].includes(
				stage.stageCode
			));

	const renderLoading = () => (
		<div
			style={{
				position: 'fixed',
				inset: 0,
				zIndex: 9999,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				background: 'white',
			}}>
			<Loading />
		</div>
	);

	const isMagicTokenUnauthorized = (() => {
		if (isMagicTokenMissing) return true;
		const fetchTokenError: any = error?.fetchToken;
		if (!fetchTokenError) return false;

		const status = fetchTokenError?.status;
		const message = (
			fetchTokenError?.message ||
			fetchTokenError?.error ||
			''
		).toString();

		return (
			status === 401 ||
			status === 403 ||
			/expired|unauthori[sz]ed|invalid\s*token|magic\s*token/i.test(message)
		);
	})();

	useEffect(() => {
		if (
			isSessionPostComplete === false ||
			([true, null].includes(isSessionPostComplete) &&
				[token, reservation, profiles, propertyInfo].every((element) => {
					return element;
				}))
		) {
			dispatch(display(false));
			dispatch(resetPostComplete());
		}
	}, [token, reservation, profiles, propertyInfo, isSessionPostComplete]);

	useEffect(() => {
		if (isMagicAuthResolved && token && !propertyInfo)
			dispatch(fetchPropertyInfo(token));
	}, [isMagicAuthResolved, token, JSON.stringify(propertyInfo)]);

	// useEffect(() => {
	// 	if (isMagicAuthResolved && token && !uiProperties)
	// 		dispatch(fetchUIProperties(token));
	// }, [isMagicAuthResolved, token, JSON.stringify(uiProperties)]);

	useEffect(() => {
		if (isMagicAuthResolved && token && !stages)
			dispatch(
				fetchStages({ token: token, type: process.env.REACT_APP_TYPE! })
			);
	}, [isMagicAuthResolved, token, JSON.stringify(stages)]);

	useEffect(() => {
		if (
			currentProfile &&
			currentProfile?.profileID > 0 &&
			stage &&
			stage !== '' &&
			stage !== null
		) {
			/* eslint-disable no-debugger */
			// debugger;
			/* eslint-enable no-debugger */
			setShowStage(true);
		}
	}, [currentProfile?.profileID, JSON.stringify(stage)]);
	// useEffect(() => {
	// 	if (token && stages && !stage && reservation?.PmsConfirmationNo)
	// 		dispatch(
	// 			fetchStage({
	// 				token: token,
	// 				type: process.env.REACT_APP_TYPE!,
	// 				confirmationNo: reservation?.PmsConfirmationNo,
	// 				stages: stages,
	// 			})
	// 		);
	// }, [
	// 	token,
	// 	JSON.stringify(stage),
	// 	JSON.stringify(stages),
	// 	reservation?.PmsConfirmationNo,
	// ]);

	useEffect(() => {
		const orderRef = searchParams.get('orderRef') ?? '';
		//const redirectResult = (searchParams.get('redirectResult') ?? '').replace('%', '%26');
		const redirectResult = searchParams.get('redirectResult') ?? '';
		if (orderRef && redirectResult) {
			dispatch(
				callAdyenWebhook({
					token: token,
					orderRef: orderRef,
					redirectResult: redirectResult,
				})
			).then(() => {
				const newSearchParams = orderRef.split('@');

				setTimeout(() => {
					window.location.href =
						window.location.origin +
						window.location.pathname +
						'?confirmationNumber=' +
						newSearchParams[0] +
						'&propertyCode=' +
						newSearchParams[1];
				}, 3000);
			});
		}
	}, [searchParams]);

	useEffect(() => {
		const confirmationNumber =
			(searchParams.get('confirmationNumber') ||
				searchParams.get('reservation')) ??
			'';
		const magicToken =
			searchParams.get('token') ||
			searchParams.get('magicToken') ||
			searchParams.get('x-magic-token') ||
			sessionStorage.getItem('magicToken') ||
			'';

		if (
			isMagicAuthResolved &&
			propertyInfo !== null &&
			propertyInfo !== undefined &&
			propertyInfo?.propertyCode !== null &&
			propertyInfo?.propertyCode !== undefined &&
			propertyInfo?.propertyCode !== '' &&
			token &&
			!reservation &&
			(confirmationNumber || magicToken)
		) {
			dispatch(
				fetchReservation({
					token: token,
					confirmationNo: confirmationNumber,
					propertyCode: propertyInfo?.propertyCode ?? '',
				})
			);
		}
	}, [
		isMagicAuthResolved,
		token,
		JSON.stringify(reservation),
		JSON.stringify(propertyInfo),
		searchParams,
	]);

	useEffect(() => {
		if (stage?.stepCode === 'SEI13' || stage?.stageCode === 'SEI13') {
			setTimeout(() => {
				bypassConfirmLeaveOnce();
				window.location.reload();
			}, 1000);
		}
	}, [stage?.stepCode, stage?.stageCode]);

	useEffect(() => {
		if (token && reservation && profiles && stage) dispatch(display(false));
	}, [
		token,
		JSON.stringify(reservation),
		JSON.stringify(profiles),
		JSON.stringify(stage),
	]);

	useEffect(() => {
		if (
			isMagicAuthResolved &&
			token &&
			!profiles &&
			reservation?.PmsConfirmationNo
		)
			dispatch(
				fetchReservationProfiles({
					token,
					confirmationNo: reservation?.PmsConfirmationNo,
				})
			);
	}, [
		isMagicAuthResolved,
		token,
		JSON.stringify(profiles),
		reservation?.PmsConfirmationNo,
	]);

	useEffect(() => {
		if (
			reservation &&
			stage &&
			stages &&
			missing.includes(stage.stepID) &&
			reservation?.PmsConfirmationNo
		)
			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
					profileID: currentProfile?.profileID ?? null,
				})
			);
	}, [
		token,
		JSON.stringify(stage),
		JSON.stringify(stages),
		JSON.stringify(reservation),
	]);

	/*
	 * To handle completeStage universal across all components
	 * completeStage is executed every time a page's POST request is fulfilled.
	 * This state of fulfillment is captured in every slice, with slice.isPostComplete.
	 * Note that: profile, document, signature are tightly coupled in the "parent component".
	 * The following useEffect is designed to work only on pages, and not parts of flows.
	 * Hence, the 3 components above are handled separately in the parent component.
	 */
	useEffect(() => {
		if (isSessionPostComplete && reservation?.PmsConfirmationNo) {
			dispatch(display(true));
			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
					profileID: currentProfile?.profileID ?? null,
				})
			);
			dispatch(resetPostComplete());
		}
	}, [isSessionPostComplete, reservation?.PmsConfirmationNo]);

	// useEffect(() => {
	// 	if (isMagicAuthResolved && token && !settings)
	// 		dispatch(fetchSettingLists(token));
	// }, [isMagicAuthResolved, token, JSON.stringify(settings)]);

	// useEffect(() => {
	// 	if (isMagicAuthResolved && token && !multiTexts)
	// 		dispatch(fetchTexts({ token: token, language: 'en' }));
	// }, [isMagicAuthResolved, token, JSON.stringify(multiTexts)]);

	const [isPortrait, setIsPortrait] = useState(
		window.matchMedia('(orientation: portrait)').matches
	);
	const [isMobile, setIsMobile] = useState(isMobileDevice());

	useEffect(() => {
		const mediaQuery = window.matchMedia('(orientation: portrait)');

		const handleOrientationChange = (e: MediaQueryListEvent) => {
			setIsPortrait(e.matches);
		};

		mediaQuery.addEventListener('change', handleOrientationChange);

		return () => {
			mediaQuery.removeEventListener('change', handleOrientationChange);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(isMobileDevice());
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		let idleTimer: NodeJS.Timeout;

		const resetTimer = () => {
			if (idleTimer) clearTimeout(idleTimer);
			idleTimer = setTimeout(() => {
				window.location.reload();
			}, 15 * 60 * 1000); // 15 minutes
		};

		resetTimer();

		const startIdleTimer = () => resetTimer();

		window.addEventListener('mousemove', startIdleTimer);
		window.addEventListener('keypress', startIdleTimer);
		window.addEventListener('click', startIdleTimer);
		window.addEventListener('scroll', startIdleTimer);
		window.addEventListener('touchstart', startIdleTimer);

		return () => {
			if (idleTimer) clearTimeout(idleTimer);
			window.removeEventListener('mousemove', startIdleTimer);
			window.removeEventListener('keypress', startIdleTimer);
			window.removeEventListener('click', startIdleTimer);
			window.removeEventListener('scroll', startIdleTimer);
			window.removeEventListener('touchstart', startIdleTimer);
		};
	}, []);

	if (isMobile && !isPortrait) {
		return (
			<div
				style={{
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					background: '#000',
					color: '#fff',
					textAlign: 'center',
					padding: '20px',
				}}>
				<h2>Please rotate your device</h2>
				<p>This application works only in portrait mode.</p>
			</div>
		);
	} else if (isMagicTokenUnauthorized) {
		return (
			<div
				className="theme-background d-flex justify-content-center align-items-center"
				style={{ minHeight: '100vh' }}>
				<div
					className="bg-white p-4 rounded shadow-sm text-center"
					style={{ width: '100%', maxWidth: '420px' }}>
					<h4 className="mb-3">Pre-checkin Link Expired</h4>

					<p className="text-muted mb-0">
						We are sorry, this pre-check-in link has expired and is no longer
						valid.
					</p>
				</div>
			</div>
			// <div
			// 	className="theme-background d-flex justify-content-center align-items-center"
			// 	style={{ minHeight: '100vh' }}>
			// 	<div
			// 		className="bg-white p-4 rounded shadow-sm"
			// 		style={{ width: '100%', maxWidth: '480px' }}>
			// 		<h4 className="mb-2">Pre-check-in Link Expired</h4>
			// 		<p className="mb-3">
			// 			Your link is unauthorized or expired. Enter reservation no, arrival
			// 			date, and email to regenerate a new pre-check-in link.
			// 		</p>
			// 		<input
			// 			type="text"
			// 			className="form-control mb-3"
			// 			placeholder="Reservation No"
			// 			value={regenerateReservationNo}
			// 			onChange={(e) => setRegenerateReservationNo(e.target.value)}
			// 		/>
			// 		<input
			// 			type="date"
			// 			className="form-control mb-3"
			// 			value={regenerateArrivalDate}
			// 			onChange={(e) => setRegenerateArrivalDate(e.target.value)}
			// 		/>
			// 		<input
			// 			type="email"
			// 			className="form-control mb-3"
			// 			placeholder="email@domain.com"
			// 			value={regenerateEmail}
			// 			onChange={(e) => setRegenerateEmail(e.target.value)}
			// 		/>
			// 		<button
			// 			type="button"
			// 			className="btn btn-dark w-100"
			// 			onClick={handleRegeneratePrecheckinLink}
			// 			disabled={isRegeneratingLink}>
			// 			{isRegeneratingLink
			// 				? 'Regenerating...'
			// 				: 'Regenerate Pre-Checkin Link'}
			// 		</button>
			// 		{regenerateError && (
			// 			<p className="text-danger mt-3 mb-0">{regenerateError}</p>
			// 		)}
			// 		{regenerateSuccess && (
			// 			<p className="text-success mt-3 mb-0">{regenerateSuccess}</p>
			// 		)}
			// 	</div>
			// </div>
		);
	} else if (
		!isMagicAuthResolved ||
		loading ||
		!token ||
		!propertyInfo ||
		!stages
	) {
		return renderLoading();
	} else {
		return (
			<div className="theme-background">
				{/* Always show home page initially */}
				{!loading && propertyInfo && !currentProfile && (
					// <ReservationProfileFormHome />
					<ReservationProfileFormHome setGuestWithMe={setGuestWithMe} />
					// <IncodeComponent />
					// <SendRegistrationCardHome />
				)}

				{stage && showStage === true && renderStage()}

				{guestVerificationLazyLoad && renderLoading()}
			</div>
		);
	}
}
